module.exports = __webpack_public_path__ + "static/media/bg.61127f71.png";